import axios from 'axios';
import {
  CONNECTION_ERROR_CODES,
  UNKNOWN_AXIOS_ERROR_CODE,
  UNKNOWN_ERROR,
} from '../getErrorMessage/getErrorMessage.constants';
import { isSerializedError } from './isSerializedError';

export const getErrorCode = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    let code = UNKNOWN_AXIOS_ERROR_CODE;
    try {
      if (error.response) {
        if (typeof error.response.data === 'object') {
          code = error.response.data.errorId;
        } else if (typeof error.response.data === 'string') {
          code = JSON.parse(error.response.data).errorId;
        }
        if (code === undefined || code === null) {
          code = `${error.response.status}`;
        }
      } else if (error.code && CONNECTION_ERROR_CODES.includes(error.code)) {
        code = error.code;
      }
    } catch (e) {
      code = UNKNOWN_AXIOS_ERROR_CODE;
    }
    return code;
  }
  if (isSerializedError(error) && error.code) {
    return error.code;
  }
  return UNKNOWN_ERROR;
};
